import type { ApiSchemas } from '@/lib/api';

// Generated from the API's OpenAPI document, never hand-written (ADR-0001): a renamed field
// breaks this build at the call site instead of rendering `undefined`.
export type InactivityStatus = ApiSchemas['InactivityStatusRead'];
export type BlockedEstablishment = ApiSchemas['BlockedEstablishmentRead'];
export type InactivityNotice = ApiSchemas['NoticeRead'];
export type NoticeKind = InactivityNotice['kind'];
export type ReactivationRequestResult = ApiSchemas['ReactivationRequestRead'];

export type InactivityPolicy = ApiSchemas['InactivityPolicyRead'];
export type InactivityPolicyUpdate = ApiSchemas['InactivityPolicyUpdate'];
export type EstablishmentStanding = ApiSchemas['EstablishmentStandingRead'];
export type EstablishmentStandingList = ApiSchemas['EstablishmentStandingList'];
export type StandingStage = EstablishmentStanding['stage'];
export type StandingSummary = ApiSchemas['StandingSummaryRead'];
export type UnitRuleUpdate = ApiSchemas['UnitRuleUpdate'];
export type PostponementCreate = ApiSchemas['PostponementCreate'];
export type InactivityEvent = ApiSchemas['InactivityEventRead'];
export type InactivityEventPage = ApiSchemas['InactivityEventPage'];
export type InactivityRun = ApiSchemas['InactivityRunRead'];

/** The chips above the Unidades table, as the API names them. */
export type StandingFilter = 'at_risk' | 'blocked' | 'exceptions' | 'all';

/** The `reason` every tenant route answers with while the customer is locked out. */
export const LOCKED_REASON = 'customer_locked_inactivity';
